import React, {Component} from 'react'
import DocumentTitle from 'react-document-title'
import style from './style.sass'

const videos = {
  'how-to-build-trading-signals': {
    title: 'How to build trading signals',
    src: 'g3rPD2Edcws?rel=0&showinfo=0'
  },
  'setting-up-live-or-paper-trading': {
    title: 'Setting up Live or Paper Trading',
    src: 'vYgbP4rq90I?rel=0&showinfo=0'
  },
  'macd': {
    title: 'Sample Trading Strategy - MACD',
    src: '45loQkV5ryc?rel=0&showinfo=0'
  },
  'etf': {
    title: 'Sample Trading Strategy - ETF',
    src: 'g_y8m_uytHE?rel=0&showinfo=0'
  }
}

class Videos extends Component {
  render() {
    const video = videos[this.props.match.params.video]
    return(
      <div styleName='wrapper'>
        <DocumentTitle title='Videos'/>
        <h2>{video.title}</h2>
        <div styleName='video-container'>
          <iframe styleName='item' src={'https://www.youtube.com/embed/'+video.src} allowFullScreen></iframe>
        </div>
      </div>
    )
  }
}

export default Videos
